import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Label, Option, Select } from '@alefeducation/ui-elements-library-core';
import { StyledLabelContainer } from './OrganisationEditorModal';
import {
  useGetVirtualTenantsByTenant,
  VirtualTenant,
} from '../../apollo/queries/virtualTenant/getVirtualTenants.queries';

interface Props {
  disabled?: boolean;
  tenantCode: string;
  selectedVirtualTenant: VirtualTenant | undefined;
  width?: string;
  onChange: (virtualTenant: VirtualTenant | undefined) => void;
}

const StyledContainer = styled.div<{ width: string }>`
  display: flex;
  width: ${({ width }) => width};
  flex-direction: column;
`;

const VirtualTenantDropDown = ({
  disabled,
  tenantCode,
  selectedVirtualTenant,
  onChange,
  width = '100%',
}: Props) => {
  const [virtualTenant, setVirtualTenant] = useState<VirtualTenant | undefined>(
    selectedVirtualTenant,
  );

  const { virtualTenants } = useGetVirtualTenantsByTenant(tenantCode);

  useEffect(() => {
    setVirtualTenant(selectedVirtualTenant);
  }, [selectedVirtualTenant]);

  const resolveVirtualTenant = (code: string) =>
    virtualTenants.find((virtualTenant) => virtualTenant.code === code);

  return (
    <StyledContainer width={width}>
      <StyledLabelContainer>
        <Label title="Virtual Tenant" />
      </StyledLabelContainer>
      <Select
        disabled={disabled}
        searchable
        data-testid="select-virtual-tenant"
        selectedOption={virtualTenant?.code}
        onSelectChange={(_id, name) => {
          onChange(resolveVirtualTenant(name));
        }}
        placeholder={
          disabled ? virtualTenant?.code || '' : 'Select Virtual Tenant'
        }
      >
        {virtualTenants.map((virtualTenant) => (
          <Option key={virtualTenant.uuid}>{virtualTenant.code}</Option>
        ))}
      </Select>
    </StyledContainer>
  );
};

export default VirtualTenantDropDown;
